module.exports = __webpack_public_path__ + "static/img/1_3_2.6b6d1c88.jpg";